export { default as LoginPage } from './login-page';